import { render, staticRenderFns } from "./CustLogType.vue?vue&type=template&id=63b19798&"
import script from "./CustLogType.vue?vue&type=script&lang=js&"
export * from "./CustLogType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports